<template>
    <auth-template>
        <b-col md="12" sm="8">
            <b-card no-body class="mx-4">
                <b-card-body class="p-4">
                    <b-form>
                        <h1> <h1>Dados Pessoais</h1></h1>
                        <p class="text-muted">Solicitar Cadastro de Gestor</p>
                        <div>
                            <span>
                                <b-alert v-if="alerta_pre_cadastro" show variant="warning">{{mensagem_pre_cadastro}}</b-alert>
                                <b-row>
                                    <b-col cols="3">
                                        <b-form-group label="CPF:">
                                            <b-input-group class="mb-6">
                                                <b-input-group-prepend>
                                                    <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input v-mask="'###.###.###-##'"
                                                              type="text"
                                                              class="form-control"
                                                              placeholder="CPF"
                                                              autocomplete="cpf"
                                                              v-model="$v.form.cpf.$model"
                                                              :state="chkState('cpf')"
                                                              autofocus
                                                              :disabled="disabled_gov"
                                                              />
                                                <b-form-invalid-feedback id="input1LiveFeedback1">CPF é obrigatório.</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="3">
                                        <b-form-group label="RG:">
                                            <b-input-group class="mb-6">
                                                <b-input-group-prepend>
                                                    <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input min="8"
                                                              max="14"
                                                              type="text"
                                                              v-mask="'###########'"
                                                              class="form-control"
                                                              placeholder="RG"
                                                              autocomplete="rg"
                                                              v-model="$v.form.rg.$model"
                                                              :state="chkState('rg')"
                                                              />
                                                <b-form-invalid-feedback id="input1LiveFeedback1">RG é obrigatório.</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="3">
                                        <b-form-group label="Órgão Expedidor:">
                                            <b-input-group class="mb-1">
                                                <b-input-group-prepend>
                                                    <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input type="text"
                                                              class="form-control"
                                                              placeholder="Órgão Expedidor"
                                                              autocomplete="orgaoExpeditor"
                                                              v-model.trim="$v.form.orgaoExpeditor.$model"
                                                              :state="chkState('orgaoExpeditor')"/>
                                                <b-form-invalid-feedback id="input1LiveFeedback3">Órgão Expedidor é obrigatório.
                                                </b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="3">
                                        <b-form-group label="Data de Nascimento:">
                                            <b-input-group>
                                                <div class="input-group-prepend">
                                                        <span class="input-group-text">
                                                        <i class='fa fa-calendar'></i>
                                                        </span>
                                                </div>
                                                <b-form-input id="type-date"
                                                              type="date"
                                                              v-model="dataNascimento"
                                                              v-model.lazy.trim="$v.form.date.$model"
                                                              :max="this.maxbirthday"
                                                              :disabled="disabled_gov"
                                                              :state="chkState('date')"></b-form-input>
                                                <b-form-invalid-feedback id="input1LiveFeedback2">Data de Nascimento é obrigatória.
                                                </b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="8">
                                        <b-form-group label="Nome Completo:">
                                            <b-input-group class="mb-3">
                                                <b-input-group-prepend>
                                                    <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input type="text"
                                                              class="form-control"
                                                              placeholder="Nome Completo"
                                                              autocomplete="nome"
                                                              v-model.trim="$v.form.nome.$model"
                                                              :state="chkState('nome')"
                                                              :disabled="disabled_gov"
                                                              />
                                                <b-form-invalid-feedback id="input1LiveFeedback3">Nome é obrigatório.</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="4">
                                        <b-form-group label="Selecione o município em que você deseja participar:">
                                            <b-form-select placeholder="Selecione"
                                                           class="mb-3"
                                                           v-model.lazy.trim="$v.form.municipio_atuacao.$model"
                                                           :state="chkState('municipio_atuacao')">
                                                <option v-for="item in municipiosprogramas" :key="item.id" :value="item.municipio_id"> {{item.cidade.cidade + " - " + item.estado.sigla}}</option>
                                                <option selected :value="null"> Selecione</option>
                                            </b-form-select>
                                            <b-form-invalid-feedback id="input1LiveFeedback12">Município que deseja participar é obrigatório.</b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="4">
                                        <b-form-group label="Profissão/Ocupação:">
                                            <b-input-group class="mb-3">
                                                <b-input-group-prepend>
                                                    <b-input-group-text><i class="fa fa-id-badge" aria-hidden="true"></i></b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input type="text"
                                                              class="form-control"
                                                              placeholder="Profissão/Ocupação:"
                                                              autocomplete="nome"
                                                              v-model.trim="$v.form.profissao.$model"
                                                              :state="chkState('profissao')"/>
                                                <b-form-invalid-feedback id="input1LiveFeedback3">Profissão/Ocupação é obrigatório.
                                                </b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="4">
                                        <b-form-group label="Estado Civil:">
                                            <b-form-select v-model.lazy.trim="$v.form.estado_civil.$model" placeholder="Password"
                                                           :options="estadoscivis"
                                                           class="mb-3" :state="chkState('estado_civil')">
                                                <option selected :value="null"> Selecione</option>
                                            </b-form-select>
                                            <b-form-invalid-feedback id="input1LiveFeedback5">Estado Civíl é obrigatório.
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="4">
                                        <b-form-group label="Escolaridade:">
                                            <b-form-select v-model.lazy.trim="$v.form.escolaridade.$model" placeholder="Password"
                                                           :options="escolaridades"
                                                           class="mb-3" :state="chkState('escolaridade')">
                                                <option selected :value="null"> Selecione</option>
                                            </b-form-select>
                                            <b-form-invalid-feedback id="input1LiveFeedback5">Escolaridade é obrigatório.
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="4">
                                        <b-form-group label="DDD + Telefone Celular:">
                                            <b-input-group class="mb-3">
                                                <b-input-group-prepend>
                                                    <b-input-group-text><i class="fa fa-phone"></i></b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input type="text"
                                                              v-mask="'+55 (##) #####-####'"
                                                              class="form-control"
                                                              placeholder="Telefone"
                                                              autocomplete="telefone"
                                                              v-model.lazy.trim="$v.form.telefone.$model"
                                                              :state="chkState('telefone')"/>
                                                <b-form-invalid-feedback :state="chkState('telefone')" id="input1LiveFeedback4">Telefone é obrigatório.
                                                </b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="2">
                                        <b-form-group label="UF:">
                                            <b-form-select v-model.lazy.trim="$v.form.uf.$model" placeholder="Password" :options="estados"
                                                           class="mb-3" :state="chkState('uf')">
                                                <option selected :value="null"> Selecione</option>
                                            </b-form-select>
                                            <b-form-invalid-feedback id="input1LiveFeedback5">UF é obrigatório.</b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="6">
                                        <b-form-group label="Município:"
                                                      :disabled="disabled_cidades">
                                            <b-form-select placeholder="Password"
                                                           :options="cidades"
                                                           class="mb-3"
                                                           v-model.lazy.trim="$v.form.municipio.$model"
                                                           :state="chkState('municipio')">
                                                <option selected :value="null"> Selecione</option>
                                            </b-form-select>
                                            <b-form-invalid-feedback id="input1LiveFeedback6">Município é obrigatório.</b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <!-- <b-col cols="3">
                                        <b-form-group label="Sexo:">
                                            <b-form-radio-group v-model.trim="$v.form.sexo.$model" :state="chkState('sexo')"
                                                                :options="optionsSexo" name="radio-inline"></b-form-radio-group>
                                        </b-form-group>
                                    </b-col> -->
                                    <b-col cols="3">
                                        <b-form-group label="CEP:">
                                            <b-input-group class="mb-3">
                                                <b-input-group-prepend>
                                                    <b-input-group-text><i class="fa fa-address-card" aria-hidden="true"></i></b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input type="text"
                                                              v-mask="'#####-###'"
                                                              class="form-control"
                                                              placeholder="CEP"
                                                              autocomplete="cep"
                                                              v-model.lazy.trim="$v.form.cep.$model"
                                                              :state="chkState('cep')"/>
                                                <b-form-invalid-feedback id="input1LiveFeedback3">CEP é obrigatório.</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="6">
                                        <b-form-group label="Endereço:">
                                            <b-input-group class="mb-3">
                                                <b-input-group-prepend>
                                                    <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input type="text"
                                                              class="form-control"
                                                              placeholder="Endereço"
                                                              autocomplete="endereco"
                                                              v-model.trim="$v.form.endereco.$model"
                                                              :state="chkState('endereco')"/>
                                                <b-form-invalid-feedback id="input1LiveFeedback3">Endereço é obrigatório.
                                                </b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="3">
                                        <b-form-group label="Número:">
                                            <b-input-group class="mb-3">
                                                <b-input-group-prepend>
                                                    <b-input-group-text><i class="fa fa-map-marker"></i></b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input type="text"
                                                              class="form-control"
                                                              v-mask="'######'"
                                                              placeholder="Número"
                                                              autocomplete="numero"
                                                              v-model.trim="$v.form.numero.$model"
                                                              :state="chkState('numero')"/>
                                                <b-form-invalid-feedback id="input1LiveFeedback3">Número é obrigatório.
                                                </b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="5">
                                        <b-form-group label="Complemento:">
                                            <b-input-group class="mb-3">
                                                <b-input-group-prepend>
                                                    <b-input-group-text><i class="fa fa-map-marker"></i></b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input type="text"
                                                              class="form-control"
                                                              placeholder="Complemento"
                                                              autocomplete="complemento"
                                                              v-model.trim="$v.form.complemento"
                                                              />
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="4">
                                        <b-form-group label="Bairro:">
                                            <b-input-group class="mb-3">
                                                <b-input-group-prepend>
                                                    <b-input-group-text><i class="fa fa-map-marker"></i></b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input type="text"
                                                              class="form-control"
                                                              placeholder="Bairro"
                                                              autocomplete="bairro"
                                                              v-model.trim="$v.form.bairro.$model"
                                                              :state="chkState('bairro')"/>
                                                <b-form-invalid-feedback id="input1LiveFeedback3">Bairro é obrigatório.
                                                </b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="6">
                                        <b-form-group label="E-mail:">
                                            <b-input-group class="mb-3">
                                                <b-input-group-prepend>
                                                    <b-input-group-text>@</b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input type="text"
                                                              class="form-control"
                                                              placeholder="E-mail"
                                                              autocomplete="email"
                                                              v-model.trim="$v.form.email.$model"
                                                              :state="chkState('email')"
                                                              :disabled="disabled_gov"
                                                              />
                                                <b-form-invalid-feedback id="input1LiveFeedback7">Este é um campo obrigatório, e deve ser um
                                                    endereço de e-mail válido.
                                                </b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="6">
                                        <b-form-group label="Confirme o e-mail:">
                                            <b-input-group class="mb-3">
                                                <b-input-group-prepend>
                                                    <b-input-group-text>@</b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input type="text"
                                                              class="form-control"
                                                              id="confirmar-email"
                                                              placeholder="Confirme o e-mail"
                                                              oncut="return false"
                                                              onpaste="return false"
                                                              autocomplete="confirme-email"
                                                              v-model.trim="$v.form.confirmaEmail.$model"
                                                              :state="chkState('confirmaEmail')"
                                                              :disabled="disabled_gov"
                                                              />
                                                <b-form-invalid-feedback id="input1LiveFeedback8">Este é um campo obrigatório, e deve ser
                                                    correspondente ao campo e-mail.
                                                </b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                  <b-col cols="12">
                                    <label>Anexar CPF:</label>
                                    <span class="icon-info" v-b-popover.hover.top="'Permitidos apenas imagens e arquivos .pdf'" title="CPF"></span>
                                    <b-form-file browse-text="Selecione" :state="stateCPF" placeholder="Selecione o documento" v-on:change="uploadCPF"></b-form-file>
                                    <b-form-invalid-feedback :state="stateCPF" id="input1LiveFeedback3"
                        >Anexo CPF é obrigatório.
                      </b-form-invalid-feedback>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <b-col cols="12">
                                    <label>Anexar RG:</label>
                                    <span class="icon-info" v-b-popover.hover.top="'Permitidos apenas imagens e arquivos .pdf'" title="RG"></span>
                                    <b-form-file browse-text="Selecione" placeholder="Selecione o documento" v-on:change="uploadRG" :state="stateIdentidade"
                      ></b-form-file>
                      <b-form-invalid-feedback id="input1LiveFeedback3"
                        >Identidade (RG) é obrigatório.
                      </b-form-invalid-feedback>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <b-col cols="12">
                                    <label>Anexar Instrumento de Representação:</label>
                                    <span class="icon-info" v-b-popover.hover.top="'Permitidos apenas imagens e arquivos .pdf'" title="Instrumento e Representação"></span>
                                    <b-form-file :state="stateInstrumentoRepresentacao" browse-text="Selecione" placeholder="Selecione o documento" v-on:change="uploadInstrumentoRepresentacao"></b-form-file>
                                    <b-form-invalid-feedback :state="stateInstrumentoRepresentacao" id="input1LiveFeedback3"
                        >Instrumento de Representação é
                        obrigatório.</b-form-invalid-feedback
                      >
                                  </b-col>
                                </b-row>
                                <!-- <b-row>
                                  <b-col cols="12">
                                    <label>Anexar Documento Oficial:</label>
                                    <span class="icon-info" v-b-popover.hover.top="'Permitidos apenas imagens e arquivos .pdf'" title="Documento Oficial"></span>
                                    <b-form-file browse-text="Selecione" placeholder="Selecione o documento" v-on:change="uploadDocumentoOficial"></b-form-file>
                                  </b-col>
                                </b-row> -->
                                <br>
                                <h2>Dados Institucionais</h2>
                                <b-row>
                                    <b-col cols="8">
                                        <b-form-group label="Nome Instituição:">
                                            <b-input-group class="mb-3">
                                                <b-input-group-prepend>
                                                    <b-input-group-text><i class="fa fa-university" aria-hidden="true"></i></b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input type="text"
                                                              class="form-control"
                                                              placeholder="Nome Instituição"
                                                              autocomplete="nomeInstituicao"
                                                              v-model.trim="$v.form.nomeInstituicao.$model"
                                                              :disabled="disableDadosInstitucionais"
                                                              :state="chkState('nomeInstituicao')"/>
                                                <b-form-invalid-feedback id="input1LiveFeedback3">O Nome da Instituição é obrigatório.</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="4">
                                        <b-form-group label="E-mail Institucional:">
                                            <b-input-group class="mb-3">
                                                <b-input-group-prepend>
                                                    <b-input-group-text><i class="fa fa-university" aria-hidden="true"></i></b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input type="text"
                                                              class="form-control"
                                                              placeholder="E-mail institucional"
                                                              autocomplete="emailInstitucional"
                                                              v-model.trim="$v.form.emailInstituicao.$model"
                                                              :disabled="disableDadosInstitucionais"
                                                              :state="chkState('emailInstituicao')"/>
                                                <b-form-invalid-feedback id="input1LiveFeedback3">O E-mail da Instituição é obrigatório.</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="4">
                                        <b-form-group label="CNPJ:">
                                            <b-input-group class="mb-6">
                                                <b-input-group-prepend>
                                                    <b-input-group-text><i class="fa fa-industry" aria-hidden="true"></i></b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input v-mask="'##.###.###/####-##'"
                                                              type="text"
                                                              class="form-control"
                                                              placeholder="CNPJ"
                                                              autocomplete="cnpj"
                                                              v-model="$v.form.cnpj.$model"
                                                            
                                                              :state="chkState('cnpj')"
                                                              />
                                                <b-form-invalid-feedback id="input1LiveFeedback1">CNPJ é obrigatório.</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="2">
                                        <b-form-group label="UF:">
                                            <b-form-select v-model.lazy.trim="$v.form.uf_instituicao.$model" placeholder="Password" :options="estados"
                                                           class="mb-3" :state="chkState('uf_instituicao')" :disabled="disableDadosInstitucionais">
                                                <option selected :value="null"> Selecione</option>
                                            </b-form-select>
                                            <b-form-invalid-feedback id="input1LiveFeedback5">UF é obrigatório.</b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="6">
                                        <b-form-group label="Município:"
                                                      :disabled="disabled_cidades">
                                            <b-form-select placeholder="Password"
                                                           :options="cidadesInstituicao"
                                                           class="mb-3"
                                                           v-model.lazy.trim="$v.form.municipio_instituicao.$model"
                                                           :disabled="disableDadosInstitucionais"
                                                           :state="chkState('municipio_instituicao')">
                                                <option selected :value="null"> Selecione</option>
                                            </b-form-select>
                                            <b-form-invalid-feedback id="input1LiveFeedback6">Município é obrigatório.</b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="4">
                                        <b-form-group label="DDD + Telefone:">
                                            <b-input-group class="mb-3">
                                                <b-input-group-prepend>
                                                    <b-input-group-text><i class="fa fa-phone"></i></b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input type="text"
                                                              v-mask="'+55 (##) #####-####'"
                                                              class="form-control"
                                                              placeholder="Telefone"
                                                              autocomplete="telefone"
                                                              v-model.lazy.trim="$v.form.telefone_instituicao.$model"
                                                              :disabled="disableDadosInstitucionais"
                                                              :state="chkState('telefone_instituicao')"/>
                                                <b-form-invalid-feedback id="input1LiveFeedback4">Telefone é obrigatório.</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="4">
                                        <b-form-group label="Matrícula junto ao órgão:">
                                            <b-input-group class="mb-3">
                                                <b-input-group-prepend>
                                                    <b-input-group-text><i class="fa fa-child" aria-hidden="true"></i></b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input type="text"
                                                              class="form-control"
                                                              v-mask="'####################'"
                                                              placeholder="Matrícula junto ao órgão"
                                                              autocomplete="matricula"
                                                              :disabled="disableDadosInstitucionais"
                                                              v-model.lazy.trim="$v.form.matricula.$model"
                                                              :state="chkState('matricula')"/>
                                                <b-form-invalid-feedback id="input1LiveFeedback4">A Matrícula é obrigatória, e deve ter 20 caractéres.</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="4">
                                        <b-form-group label="Dependência Administrativa:">
                                            <b-form-select placeholder="Dependência Administrativa"
                                                           :options="dependencias"
                                                           class="mb-3"
                                                           v-model.lazy.trim="$v.form.dependenciaAdministrativa.$model"
                                                           
                                                           :state="chkState('dependenciaAdministrativa')">
                                                <option selected :value="null"> Selecione</option>
                                            </b-form-select>
                                            <b-form-invalid-feedback id="input1LiveFeedback6">Dependência Administrativa é obrigatório.</b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="4">
                                        <b-form-group label="CEP:">
                                            <b-input-group class="mb-3">
                                                <b-input-group-prepend>
                                                    <b-input-group-text><i class="fa fa-address-card" aria-hidden="true"></i></b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input type="text"
                                                              v-mask="'#####-###'"
                                                              class="form-control"
                                                              placeholder="Cep"
                                                              autocomplete="cep"
                                                              v-model.lazy.trim="$v.form.cep_instituicao.$model"
                                                              :disabled="disableDadosInstitucionais"
                                                              :state="chkState('cep_instituicao')"/>
                                                <b-form-invalid-feedback id="input1LiveFeedback4">O CEP é obrigatório.</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="8">
                                        <b-form-group label="Endereço:">
                                            <b-input-group class="mb-3">
                                                <b-input-group-prepend>
                                                    <b-input-group-text><i class="fa fa-map-signs" aria-hidden="true"></i></b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input type="text"
                                                              class="form-control"
                                                              placeholder="Endereço"
                                                              autocomplete="endereco"
                                                              v-model.trim="$v.form.endereco_instituicao.$model"
                                                              :disabled="disableDadosInstitucionais"
                                                              :state="chkState('endereco_instituicao')"/>
                                                <b-form-invalid-feedback id="input1LiveFeedback4">O Endereço é obrigatório.</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="5">
                                        <b-form-group label="Bairro:">
                                            <b-input-group class="mb-3">
                                                <b-input-group-prepend>
                                                    <b-input-group-text><i class="fa fa-map-marker"></i></b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input type="text"
                                                              class="form-control"
                                                              placeholder="Bairro"
                                                              autocomplete="bairro"
                                                              v-model.trim="$v.form.bairroInstitucional.$model"
                                                              :state="chkState('bairroInstitucional')"/>
                                                <b-form-invalid-feedback id="input1LiveFeedback4">O Bairro é obrigatório.</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="5">
                                        <b-form-group label="Complemento:">
                                            <b-input-group class="mb-3">
                                                <b-input-group-prepend>
                                                    <b-input-group-text><i class="fa fa-map-marker"></i></b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input type="text"
                                                              class="form-control"
                                                              placeholder="Complemento"
                                                              autocomplete="complemento"
                                                              :disabled="disableDadosInstitucionais"
                                                              v-model.trim="$v.form.complementoInstitucional"
                                                              />
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="2">
                                        <b-form-group label="Número:">
                                            <b-input-group class="mb-3">
                                                <b-input-group-prepend>
                                                    <b-input-group-text><i class="fa fa-map-marker"></i></b-input-group-text>
                                                </b-input-group-prepend>
                                                <b-form-input type="text"
                                                              class="form-control"
                                                              placeholder="Número"
                                                              v-mask="'######'"
                                                              autocomplete="numero"
                                                              v-model.trim="$v.form.numeroInstitucional.$model"
                                                              :disabled="disableDadosInstitucionais"
                                                              :state="chkState('numeroInstitucional')"/>
                                                <b-form-invalid-feedback id="input1LiveFeedback4">O Número é obrigatório.</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                  <b-col cols="8">
                                    <b-form-group label="URL:">
                                          <b-input-group class="mb-3">
                                              <b-input-group-prepend>
                                                  <b-input-group-text><i class="fa fa-map-signs" aria-hidden="true"></i></b-input-group-text>
                                              </b-input-group-prepend>
                                              <b-form-input type="text"
                                                            class="form-control"
                                                            placeholder="URL"
                                                            autocomplete="url"
                                                            v-model.trim="$v.form.url_instituicao.$model"
                                                            :state="chkState('url_instituicao')"/>
                                          </b-input-group>
                                      </b-form-group>
                                  </b-col>
                                </b-row>
                               <!-- <b-row>
                                    <b-col cols="12">
                                        <label>Anexar Documento:</label>
                                         <span class="icon-info" v-b-popover.hover.top="'Permitidos apenas imagens e arquivos .pdf'" title="Informação"></span>
                                        <b-form-group label-for="nome-input" invalid-feedback="Documento é obrigatório" :state="stateDocumento">
                                            <b-form-file browse-text="Selecione" placeholder="Selecione o documento" :state="stateDocumento" v-on:change="uploadDocumento"></b-form-file>
                                            <b-form-invalid-feedback id="input1LiveFeedback3">Documento é obrigatório.</b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                </b-row>-->
                                <b-row>
                                    <b-col cols="11">
                                        <br>
                                        <b-form-checkbox
                                                v-model="valueAceiteCadastro"
                                                :options="options2"
                                                :disabled="disabled_regulamento"
                                                :state="valueAceiteCadastro"
                                                name="checkbox-validation">Confirmo a leitura e aceite do <a style="text-decoration: underline;" @click="abrirModalRegulamento()">regulamento</a>.
                                        </b-form-checkbox>
                                        <b-form-invalid-feedback :state="valueAceiteCadastro">A aceitação é obrigatória para completar o seu
                                            cadastro.
                                        </b-form-invalid-feedback>
                                    </b-col>
                                </b-row>
                                <br>
                                <b-row>
                                    <b-col cols="11">
                                        <br>
                                        <b-form-checkbox
                                                v-model="valueAceiteDeclaracao"
                                                :options="options3"
                                                :state="valueAceiteDeclaracao"
                                                name="checkbox-validation">Declaro, para os devidos fins, que concordo com o tratamento dos dados informados para a participação no Projeto Mães Unidas. Ao concordar, eu autorizo que o Ministério da Mulher, da Família e dos Direitos Humanos tenha acesso a eles, para fins estatísticos e para aprimoramento do Projeto.
                                        </b-form-checkbox>
                                        <b-form-invalid-feedback :state="valueAceiteDeclaracao">A aceitação é obrigatória para completar o seu
                                            cadastro.
                                        </b-form-invalid-feedback>
                                    </b-col>
                                </b-row>
                                <br>
                                <b-container class="bv-example-row" v-show="valueAceiteDeclaracao && valueAceiteCadastro">
                                    <b-row>
                                        <b-col></b-col>
                                        <b-col><g-recaptcha :sitekey="chavaCaptcha"/></b-col>
                                        <b-col></b-col>
                                    </b-row>
                                </b-container>
                                 <br>
                                <b-row>
                                    <b-col class="align-items-center" cols="4">
                                        <b-button v-if="!loading" variant="primary" class="btn btn-outline-light btn-block" v-on:click="onSubmit()">Solicitar Cadastro</b-button>
                                        <b-button v-else variant="primary" class="btn btn-block" disabled>
                                            <b-spinner small type="grow"></b-spinner>Salvando...
                                        </b-button>
                                    </b-col>
                                    <b-col cols="4">
                                        <b-button variant="primary" class="btn btn-outline-light btn-block" v-if="externo" @click="navigate('/login')">Voltar para a tela de Acesso</b-button>
                                    </b-col>
                                </b-row>
                            </span>
                        </div>
                        <b-modal title="Regulamento do Projeto Mães Unidas" size="xl" scrollable no-close-on-backdrop  hide-header-close :hide-footer="true" v-model="modalRegulamento">
                          <b-card-body>
                            <b-form>
                              <Regulamento>
                              </Regulamento>
                            </b-form>
                        </b-card-body>
                        <b-card-footer class="p-12 " style="text-align: center;">
                          <b-button size="lg" @click="aprovarRegulamento" variant="primary"> OK</b-button>
                      </b-card-footer>
                      </b-modal>
                    </b-form>
                </b-card-body>
            </b-card>
        </b-col>
    </auth-template>
</template>

<script>
import Vue from 'vue'
import Regulamento from '@/templates/site-externo/Regulamento'
import VueSelect from 'vue-select'
import gRecaptcha from '../recaptcha'
import {validationMixin} from 'vuelidate'
import {required, minLength, maxLength, email, sameAs} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

const formShape = {
  cpf: '',
  rg: '',
  bairro: '',
  complemento: '',
  numero: '',
  date: '',
  orgaoExpeditor: '',
  nome: '',
  profissao: '',
  telefone: '',
  email: '',
  endereco: '',
  sexo: 'F',
  confirmaEmail: '',
  cep: '',
  uf: null,
  escolaridade: null,
  municipio: null,
  municipio_atuacao: null,
  estado_civil: null,
  tipoUsuario: 2,
  nomeInstituicao: '',
  emailInstituicao: '',
  cnpj: '',
  uf_instituicao: null,
  municipio_instituicao: null,
  telefone_instituicao: '',
  matricula: '',
  dependenciaAdministrativa: null,
  cep_instituicao: '',
  endereco_instituicao: '',
  bairroInstitucional: '',
  complementoInstitucional: '',
  numeroInstitucional: '',
  url_instituicao: null,
  arquivo_identidade: null,
  arquivo_cpf: null,
  arquivo_documento_oficial: null,
  arquivo_instrumento_representacao: null
}

export default {
  name: 'DadosPessoais',
  components: {
    Regulamento,
    VueSelect,
    gRecaptcha
  },
  mixins: [validationMixin],
  validations: {
    form: {
      cpf: {
        required,
        minLength: minLength(14)
      },
      rg: {},
      numero: {
        required
      },
      orgaoExpeditor: {},
      bairro: {
        required,
        maxLength: maxLength(25)
      },
      date: {
        // required,
        // maxLength: maxLength(15)
      },
      nome: {
        required
      },
      profissao: {
        required
      },
      endereco: {
        required
      },
      url_instituicao: {},
      cep: {
        required,
        maxLength: maxLength(9),
        minLength: minLength(9)
      },
      sexo: {},
      telefone: {
        required,
        maxLength: maxLength(19),
        minLength: minLength(19)
      },
      telefoneFixo: {
        minLength: minLength(18)
      },
      uf: {
        required
      },
      estado_civil: {},
      escolaridade: {},
      municipio: {
        required
      },
      municipio_atuacao: {
        required
      },
      email: {
        required,
        email
      },
      confirmaEmail: {
        required,
        email,
        sameAsEmail: sameAs('email')
      },
      tipoUsuario: {
        required
      },
      nomeInstituicao: {
        required
      },
      emailInstituicao: {
        required
      },
      cnpj: {
        required
      },
      matricula: {

      },
      bairroInstitucional: {
        // required
      },
      numeroInstitucional: {
        // required
      },
      telefone_instituicao: {
        required
      },
      dependenciaAdministrativa: {
        // required
      },
      uf_instituicao: {
        required
      },
      municipio_instituicao: {
        required
      },
      cep_instituicao: {
        // required,
        // maxLength: maxLength(9),
        // minLength: minLength(9)
      },
      endereco_instituicao: {
        // required
      }

    }
  },
  created () {
    this.$store.dispatch('buscarEstados')
    this.$store.dispatch('buscarTipoUsuarios')
    this.$store.dispatch('buscarEscolaridades')
    this.$store.dispatch('buscarEstadosCivil')
    this.$store.dispatch('buscarDependencias')
    this.$store.dispatch('buscarMunicipiosProgramas')
  },
  data () {
    return {
      externo: true,
      dataNascimento: null,
      loading: false,
      unico: false,
      stateComprovanteCargo: null,
      stateInstrumentoRepresentacao: null,
      stateDocumento: null,
      stateCertidao: null,
      stateIdentidade: null,
      stateLaudo: null,
      comprovanteCargo: null,
      documentoAnexo: null,
      certidao: null,
      identidade: null,
      disabled_regulamento: false,
      modalRegulamento: false,
      valueAceiteDeclaracao: false,
      laudo: null,
      perfil: 0,
      disableDadosInstitucionais: false,
      salvarForm: false,
      form: Object.assign({}, formShape),
      text: 'Declaro, para os devidos fins, que concordo com o tratamento dos dados informados para a participação no Projeto Mães Unidas. Ao concordar, eu autorizo que o Ministério da Mulher, da Família e dos Direitos Humanos tenha acesso a eles, para fins estatísticos e para aprimoramento do Projeto.',
      status_aceite: 'not_accepted',
      disabled_cidades: true,
      disable_buttons: false,
      valueAceiteTipoUsuario: false,
      valueAceiteCadastro: false,
      titulo_toast: 'Alerta!',
      options: [
        {value: true}
      ],
      options2: [
        {value: true}
      ],
      options3: [
        {value: true}
      ],
      // optionsSexo: [
      //   {text: 'Feminino', value: 'F'},
      //   {text: 'Masculino', value: 'M'}
      // ],
      alerta_pre_cadastro: false,
      mensagem_pre_cadastro: '',
      tabs: ['Dados Pessoais', 'Dados Institucionais'],
      chavaCaptcha: process.env.KEY_RECAPTCHA,
      disabled_gov: false
    }
  },
  mounted () {
    if (this.$router.currentRoute.fullPath === '/usuario/cadastrar') {
      this.externo = false
    }

    if (this.externo && !SessionStorage.get('dados-govbr')) {
      this.govbr()
    }

    if (SessionStorage.get('dados-govbr')) {
      let dadosgov = SessionStorage.getObject('dados-govbr')
      this.form.cpf = dadosgov.cpf
      this.form.nome = dadosgov.nome
      this.form.email = dadosgov.email
      this.form.confirmaEmail = dadosgov.email
      this.form.date = new Date(dadosgov.data_nascimento).toISOString().slice(0, 10)
      this.dataNascimento = new Date(dadosgov.data_nascimento).toISOString().slice(0, 10)
      this.disabled_gov = true
      SessionStorage.remove('dados-govbr')
    }
  },
  computed: {
    estados () {
      return this.$store.state.estado.listaEstados
    },
    cidades () {
      return this.$store.state.cidade.listaCidadesPorEstado
    },
    cidadesInstituicao () {
      return this.$store.state.cidade.listaCidadesPorEstadoInstituicao
    },
    listacombo () {
      return this.$store.getters.getListaCombo
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    escolaridades () {
      return this.$store.state.escolaridade.listaEscolaridade
    },
    estadoscivis () {
      return this.$store.state.estadocivil.listaEstadoCivil
    },
    municipiosprogramas () {
      return this.$store.state.municipiosprogramas.listaMunicipiosProgramas
    },
    dependencias () {
      return this.$store.state.dependencias.listaDependencias
    }
  },
  watch: {
    '$v.form.uf.$model': function () {
      if (this.$v.form.uf.$model !== null) {
        this.$store.dispatch('buscarCidadesPorEstado', this.$v.form.uf.$model)
        this.disabled_cidades = false
      } else {
        this.disabled_cidades = true
      }
    },
    '$v.form.uf_instituicao.$model': function () {
      if (this.$v.form.uf_instituicao.$model !== null) {
        this.$store.dispatch('buscarCidadesPorEstadoInstituicao', this.$v.form.uf_instituicao.$model)
        this.disabled_cidades = false
      } else {
        this.disabled_cidades = true
      }
    },
    '$v.form.tipoUsuario.$model': function () {
      this.perfil = this.$v.form.tipoUsuario.$model
      if (this.perfil === 4 || this.perfil === 5 || this.perfil === 6) {
        this.$emit('esconderaba', true)
        this.unico = true
      } else {
        this.$emit('esconderaba', false)
        this.unico = false
      }
    },
    '$v.form.cnpj.$model': function () {
      this.buscarCNPJ()
    }
  },
  methods: {
    govbr () {
      Vue.http.get('api/auth/login/uri').then(response => {
        SessionStorage.set('redirect-cadastro', 'gestor')
        let url = response.body.data.url
        location.href = url
      }).catch(e => {})
    },
    buscarCNPJ () {
      let cnpj = this.form.cnpj
      cnpj = cnpj.replace('.', '').replace('.', '').replace('/', '').replace('-', '')

      if (cnpj.length === 14) {
        Vue.http.get('api/instituicao/' + cnpj + '/cnpj').then(response => {
          let data = response.body.data
          this.form.nomeInstituicao = data.nome_instituicao
          this.form.emailInstituicao = data.email_instituicao
          this.form.municipio_instituicao = data.municipio_id
          this.form.uf_instituicao = data.municipio.estado_id
          this.form.matricula = data.matricula
          this.form.telefone_instituicao = data.telefone
          this.form.cep_instituicao = data.cep
          this.form.endereco_instituicao = data.endereco
          this.form.numeroInstitucional = data.numero
          this.form.complementoInstitucional = data.complemento
          this.form.dependenciaAdministrativa = data.dependencia_administrativa
          this.disableDadosInstitucionais = true
        }).catch(e => {
          this.limparInstituicao()
          this.disableDadosInstitucionais = false
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error('Realize o cadastro da instituição através do sistema SNDH <sndh.mdh.gov.br > para se cadastrar, utilize esse link.', 'Alerta', 5000)
        })
      }
    },
    limparInstituicao () {
      this.form.nomeInstituicao = null
      this.form.emailInstituicao = null
      this.form.cnpj = null
      this.form.municipio_instituicao = null
      this.form.telefone_instituicao = null
      this.form.cep_instituicao = null
      this.form.endereco_instituicao = null
      this.form.numeroInstitucional = null
    },
    salvar () {
      this.loading = true

      let form = this.$v.form
      let data = {
        dp_rg: form.rg.$model.replace(/[^\d]+/g, ''),
        dp_orgao_expeditor: form.orgaoExpeditor.$model,
        dp_data_nascimento: form.date.$model,
        dp_profissao: form.profissao.$model,
        dp_escolaridade: form.escolaridade.$model,
        dp_estado_civil: form.estado_civil.$model,
        dp_telefone: form.telefone.$model.replace(/[^\d]+/g, ''),
        dp_municipio_id: parseInt(form.municipio.$model),
        dp_municipio_atuacao_id: parseInt(form.municipio_atuacao.$model),
        dp_sexo: form.sexo.$model,
        dp_cep: form.cep.$model.replace(/[^\d]+/g, ''),
        dp_endereco: form.endereco.$model,
        dp_bairro: form.bairro.$model,
        dp_complemento: form.complemento,
        dp_numero: form.numero.$model.replace(/[^\d]+/g, ''),
        dp_arquivo_cargo_exercido: this.comprovanteCargo,
        dp_arquivo_comprovante_escolaridade: this.documentoAnexo,
        dp_arquivo_certidao_nascimento: this.certidao,
        dp_arquivo_atestado_gravidez: this.laudo,
        dp_arquivo_identidade: this.arquivo_identidade,
        dp_arquivo_cpf: this.arquivo_cpf,
        dp_arquivo_documento_oficial: this.arquivo_documento_oficial,
        dp_arquivo_instrumento_representacao: this.arquivo_instrumento_representacao,
        di_nome_instituicao: form.nomeInstituicao.$model,
        di_email: form.emailInstituicao.$model,
        di_url: form.url_instituicao.$model,
        di_cnpj: form.cnpj.$model.replace(/[^\d]+/g, ''),
        di_matricula: form.matricula.$model.replace(/[^\d]+/g, ''),
        di_municipio_id: parseInt(form.municipio.$model),
        di_telefone: form.telefone_instituicao.$model.replace(/[^\d]+/g, ''),
        di_dependencia_administrativa: form.dependenciaAdministrativa.$model,
        di_cep: form.cep.$model.replace(/[^\d]+/g, ''),
        di_endereco: form.endereco.$model,
        di_bairro: form.bairroInstitucional.$model,
        di_complemento: form.complementoInstitucional,
        di_numero: form.numeroInstitucional.$model.replace(/[^\d]+/g, ''),
        di_arquivo_anexo: this.documentoAnexo,
        cpf: form.cpf.$model.replace(/[^\d]+/g, ''),
        nome: form.nome.$model,
        email: form.email.$model,
        email_confirmation: form.confirmaEmail.$model,
        perfil_id: 2,
        ativo: true,
        gerarToken: true,
        captcha: window.grecaptcha.getResponse()
      }

      Vue.http.post('api/usuario', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          SessionStorage.remove('dados_pessoais')
          this.loading = false
          if (this.externo) {
            this.$router.push({path: '/login'})
          } else {
            this.$router.push({path: '/usuarios'})
          }
        } else {
          this.disable_buttons = false
          this.loading = false
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
      }).catch(e => {
        let response = e.body
        this.loading = false

        if (response.data) {
          let erros = Object.values(response.data)

          for (let erro of erros) {
            miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
            miniToastr.error(erro, 'Ops!', 9000)
          }
        }
      })
    },
    onSubmit () {
      this.salvarForm = true
      let valid = this.validateAnexos()
      if (this.validate() && this.validateTermos() && valid) {
        this.salvar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]

      if (!field.$model && !this.salvarForm) {
        return null
      }

      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    validateTermos () {
      let bool = true
      if (!this.valueAceiteCadastro || !this.valueAceiteDeclaracao) {
        bool = false
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error('Aceite os termos para criação de sua conta.', this.titulo_toast, 5000)
      }
      return bool
    },
    navigate (route) {
      this.$router.push(route)
    },
    uploadDocumento (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.documentoAnexo = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },

    uploadInstrumentoRepresentacao (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.arquivo_instrumento_representacao = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    uploadDocumentoOficial (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.arquivo_documento_oficial = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    uploadCPF (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.arquivo_cpf = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    uploadRG (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.arquivo_identidade = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    abrirModalRegulamento () {
      this.modalRegulamento = true
    },
    aprovarRegulamento () {
      this.disabled_regulamento = false
      this.valueAceiteCadastro = true
      this.modalRegulamento = false
    },
    validateAnexos () {
      let bool = true

      if (!this.arquivo_cpf) {
        this.stateCPF = false
        bool = false
      } else {
        this.stateCPF = true
      }

      if (!this.identidade) {
        this.stateIdentidade = false
        bool = false
      } else {
        this.stateIdentidade = true
      }

      if (!this.arquivo_instrumento_representacao) {
        this.stateInstrumentoRepresentacao = false
        bool = false
      } else {
        this.stateInstrumentoRepresentacao = true
      }

      return bool
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/auth/cadastro/Gestor.vue